import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

import SelectFieldRelative from '../../artzu-ui/src/SelectFieldRelative';
import Option from '../../artzu-ui/src/Option';

class SpecifyLocation extends ValidatorComponent {
  render() {
    const {
      title = '',
      onChange = () => {},
      // validators = [],
      // errorMessages = [],
      name = '',
    } = this.props;
    const { isValid } = this.state;

    return (
      <div className="" style={{ 'font-size': '16px', 'padding-top': '10px' }}>
        <SelectFieldRelative
          error={!isValid && this.getErrorMessage()}
          onChange={onChange}
          title={title}
          name={name}
          width="100%"
          style={{ 'font-size': '16px' }}>
          <Option label="Front driver side" value="front_driver_side" />
          <Option label="Front passenger side" value="front_passenger_side" />
          <Option label="Rear driver side" value="rear_driver_side" />
          <Option label="Rear passenger side" value="rear_passenger_side" />
        </SelectFieldRelative>
        <p className="error-text">{this.props.error}</p>
      </div>
    );
  }
}

export default SpecifyLocation;



// WEBPACK FOOTER //
// ./src/components/Report/SpecifyLocation.js